import React from 'react'
// import { useSelector } from 'react-redux'
// import { getColorSettings } from '../../../selectors'
// import { formatColorFromApi } from '../../../utils/formatData'

const DynamicColor = React.forwardRef(
    ({ style = {}, tag = 'div', children, ...props }, ref) => {
        const DynamicComponent = tag
        // const settings = useSelector(getColorSettings)
        // TODO: backup for dynamic color
        // const styles = Object.keys(style).reduce(
        //     (rs, current) => ({
        //         ...rs,
        //         [current]: settings[style[current]]
        //             ? formatColorFromApi(settings[style[current]])
        //             : style[current],
        //     }),
        //     {}
        // )

        return (
            <DynamicComponent ref={ref} style={style} {...props}>
                {children}
            </DynamicComponent>
        )
    }
)

export default DynamicColor
